<template>
    <div class="action-panel">
        <template v-for="item in items">
            <div class="action-divider" v-if="item.type == 'divider'" :key="item.key"></div>
        <div v-else class="action-item" :class="{
          'action-item-selected':mouse_mode == item.key
        }" @click="onClick(item.key)" :key="item.key">
            <BaseIcon :icon="item.icon" :title="item.name" :size="20" color="var(--text1)" :customClass="item.family" :customPrefix="item.prefix" />

        </div>
      </template>
    </div>
  </template>

<script>
export default {
  data() {
    return {
      mouse_mode: 'arrow',
    };
  },
  computed: {
    items() {
      return [{
        key: 'arrow',
        name: '鼠标模式',
        icon: 'plot-layer-selection',
        family: 'iflofont',
        prefix: 'iflo-',
      }, {
        key: 'selection',
        name: '框选模式',
        icon: 'Selection-Tool',
        family: 'iflofont',
        prefix: 'iflo-',
      },
      {
        type: 'divider',
      },
      {
        key: 'undo',
        name: '撤销',
        icon: 'md-undo',

      }, {
        key: 'redo',
        name: '重做',
        icon: 'md-redo',

      }, {
        key: 'save',
        name: '保存',
        icon: 'save',

      }, {
        key: 'test',
        name: '测试',
        icon: 'ios-flask',

      }, {
        type: 'divider',
      }, {
        key: 'zoom-in',
        name: '放大',
        icon: 'md-add',

      }, {
        key: 'zoom-out',
        name: '缩小',
        icon: 'md-remove',

      }, {
        key: 'expand',
        name: '居中',
        icon: 'md-locate',

      }, {
        key: 'reset',
        name: '重置',
        icon: 'md-refresh',

      }, {
        type: 'divider',
      }, {
        key: 'download',
        name: '下载图片',
        icon: 'md-download',

      }];
    },
  },
  methods: {
    onClick(key) {
      if (key == 'selection' || key == 'arrow') {
        this.mouse_mode = key;
      }
      this.$emit('on-click', key);
    },
  },
};
</script>

  <style lang="less" scoped>
  .action-panel {
    border: 3px solid var(--border);
    padding:5px 2px;
    background:var(--bg1);
    border-radius:10px;
    box-shadow: 2px 2px 3px 3px var(--border);
    display: flex;
    align-items: center;
  }

  .action-divider{
    width:1px;height:26px;
    background:#00000055;
    margin:0 5px;
  }

  .action-item {
    cursor: pointer;
    padding: 5px;
    border-radius: 5px;
    margin:0 3px;
    color:var(--text1);
    text-align: center;
  }

  .action-item:hover{
    box-shadow: 1px 1px 1px 1px var(--border);
    filter:brightness(1.1);
    i{
        transition: color 0.5s;
        color:var(--active) !important;
    }
  }

  .action-item:active{
    box-shadow: -1px -1px 1px 1px var(--border);
    filter:brightness(1.1);
    i{
        transition: color 0.5s;
        color:var(--active) !important;
    }
  }

  .action-item-selected{
    background:#00000033;
    border-top:1px solid var(--border);
    border-left:1px solid var(--border);
  }
  </style>

